import {
  diffBetweenTwoDatesInMonths,
  sortWithQuantumLebenPriorityAndReturn,
} from './utils/utils';
import { DUTCH_LOCALE, PolicyTermsEnum } from './enums/enums';

function calculateTotalPriceForAllPeriodAndAssignToResults(results) {
  results.map((rawResult) => {
    const result = rawResult;
    const {
      policyTerms,
      premiumProgression: [{
        startDate, endDate, amount,
      }],
    } = result;

    const fullPeriodCost = amount * diffBetweenTwoDatesInMonths(startDate, endDate);
    const formattedAmount = new Intl.NumberFormat(
      DUTCH_LOCALE, {
        minimumFractionDigits: 2, maximumFractionDigits: 2,
      }
    ).format(amount);
    const formattedFullPeriodCost = new Intl.NumberFormat(
      DUTCH_LOCALE, {
        minimumFractionDigits: 2, maximumFractionDigits: 2,
      }
    ).format(fullPeriodCost);

    result.premiumProgression = {
      policyTerms, amount: formattedAmount, endDate, fullPeriodCost: formattedFullPeriodCost,
    };

    return result;
  });

  return results;
}

export class PoliciesService {
  static transformResponse({ data: { results } }) {
    const resultsArray = calculateTotalPriceForAllPeriodAndAssignToResults(results);
    resultsArray.map((rawResult) => {
      const result = rawResult;

      let policyTerms = '';
      if (result.policyTerms.includes('QL_MLB')) {
        policyTerms = 'QL_MLB';
      } else if (result.policyTerms.includes('IPT_MLB')) {
        policyTerms = 'IPT_MLB';
      }

      result.policyTerms = PolicyTermsEnum[policyTerms] || PolicyTermsEnum.UNKNOWN;
      return result;
    });

    return sortWithQuantumLebenPriorityAndReturn(resultsArray);
  }
}
